import * as React from 'react';
import { UseQueryResult } from 'react-query';
import { ErrorLine } from '@uifabric/portal-ux/lib/ErrorLine';
import { Grid } from '@uifabric/portal-ux/lib/ResponsiveGrid';
import { LoadingLine } from '@uifabric/portal-ux/lib/LoadingLine';
import { ResponsiveMode } from '@fluentui/react/lib/utilities/decorators/withResponsiveMode';
import { gridUnit } from '@uifabric/portal-ux/lib/styling/stylingConstants';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';

import { IRegionalAndLanguageSettingsQueryResult } from '../../Language/hooks/useGetRegionalAndLanguageSettingQuery';
import { PdfViewer } from '../PdfViewer/PdfViewer';
import { classNames } from './TermsOfUseCardExpanded.styles';

export interface ITermsOfUseCardExpandedProps {
  readonly getPolicyFileDataQuery: UseQueryResult<unknown, unknown>;
  readonly getRegionalAndLanguageSettingsQuery?: IRegionalAndLanguageSettingsQueryResult;
}

export const TermsOfUseCardExpanded: React.FC<ITermsOfUseCardExpandedProps> = ({
  getPolicyFileDataQuery,
  getRegionalAndLanguageSettingsQuery,
}) => {
  const [t] = useLocalization('TermsOfUse');

  let pdfData = new Uint8Array();
  if (getPolicyFileDataQuery.data) {
    const decodedPdfData = atob(getPolicyFileDataQuery.data as string);
    if (decodedPdfData) {
      pdfData = Uint8Array.from(decodedPdfData, (charAsString) => charAsString.charCodeAt(0));
    }
  }
  const isPolicyFileDataNotEmpty = pdfData.length > 0;

  return (
    <div>
      <Grid
        responsiveSteps={[ResponsiveMode.medium, ResponsiveMode.large]}
        responsivePivot={ResponsiveMode.medium}
        columnPadding={[, gridUnit * 2, gridUnit * 5]}
        rowPadding={gridUnit * 2}
        className={classNames.panelExpandedClass}
      >
        {(() => {
          if (getPolicyFileDataQuery.isLoading) {
            return <LoadingLine>{t('messageTermsOfUseLoading')}</LoadingLine>;
          } else if (getPolicyFileDataQuery.isError || !isPolicyFileDataNotEmpty) {
            return <ErrorLine>{t('messageTermsOfUseNotLoaded')}</ErrorLine>;
          } else {
            return (
              <PdfViewer pdfData={pdfData} getRegionalAndLanguageSettingsQuery={getRegionalAndLanguageSettingsQuery} />
            );
          }
        })()}
      </Grid>
    </div>
  );
};
